/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ToolsetOrigin = {
  /**
   * The globally unique registry specifier this toolset originated from
   */
  registrySpecifier: string;
};

/** @internal */
export const ToolsetOrigin$inboundSchema: z.ZodMiniType<
  ToolsetOrigin,
  unknown
> = z.pipe(
  z.object({
    registry_specifier: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "registry_specifier": "registrySpecifier",
    });
  }),
);
/** @internal */
export type ToolsetOrigin$Outbound = {
  registry_specifier: string;
};

/** @internal */
export const ToolsetOrigin$outboundSchema: z.ZodMiniType<
  ToolsetOrigin$Outbound,
  ToolsetOrigin
> = z.pipe(
  z.object({
    registrySpecifier: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      registrySpecifier: "registry_specifier",
    });
  }),
);

export function toolsetOriginToJSON(toolsetOrigin: ToolsetOrigin): string {
  return JSON.stringify(ToolsetOrigin$outboundSchema.parse(toolsetOrigin));
}
export function toolsetOriginFromJSON(
  jsonString: string,
): SafeParseResult<ToolsetOrigin, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolsetOrigin$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolsetOrigin' from JSON`,
  );
}
